import { Skeleton } from '@sea-snag/ui';
import { createFileRoute } from '@tanstack/react-router';

import { DashboardGrid } from '../../components/dashboard/dashboard-grid';
import { DashboardHeader } from '../../components/dashboard/dashboard-header';
import { WidgetCatalog } from '../../components/dashboard/widget-catalog';
import { useDashboard } from '../../hooks/use-dashboard';

export const Route = createFileRoute('/$orgPid/dashboard')({
  component: DashboardPage,
});

// ── Loading Skeleton ─────────────────────────────────────────────────

function DashboardSkeleton() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="space-y-2">
          <Skeleton className="h-8 w-48" />
          <Skeleton className="h-4 w-64" />
        </div>
        <Skeleton className="h-8 w-28" />
      </div>
      <div className="grid grid-cols-12 gap-4">
        <Skeleton className="col-span-12 h-32" />
        <Skeleton className="col-span-12 h-24 md:col-span-6 lg:col-span-4" />
        <Skeleton className="col-span-12 h-24 md:col-span-6 lg:col-span-4" />
        <Skeleton className="col-span-12 h-24 md:col-span-6 lg:col-span-4" />
        <Skeleton className="col-span-12 h-48 lg:col-span-6" />
        <Skeleton className="col-span-12 h-48 lg:col-span-6" />
      </div>
    </div>
  );
}

// ── Dashboard Page ───────────────────────────────────────────────────

function DashboardPage() {
  const { layout, isLoading, isEditMode, isCatalogOpen, isSaving, toggleEditMode } = useDashboard();

  if (isLoading) {
    return <DashboardSkeleton />;
  }

  return (
    <div className="space-y-6">
      <DashboardHeader
        isEditMode={isEditMode}
        isSaving={isSaving}
        toggleEditMode={toggleEditMode}
      />
      <DashboardGrid layout={layout} isEditMode={isEditMode} />
      <WidgetCatalog layout={layout} isCatalogOpen={isCatalogOpen} />
    </div>
  );
}
